export const organizationConfig = {
  name: 'Greenbow A/S',
  description:
    'Vi leverer ladeløsninger og strøm til private husstande. Vi bygger vores forretning på ordentlighed, billige priser og brugervenlighed',
  contact: {
    email: 'hej@greenbow.dk',
    phone: '+4535103510',
    address: {
      street: 'Bygmestervej 5',
      city: 'Copenhagen',
      postalCode: '2200',
      country: 'DK'
    }
  },
  seo: {
    ogImage: 'https://greenbow.dk/greenbow-logo.png',
    twitterImage: 'https://greenbow.dk/greenbow-logo.png',
    themeColor: {
      dark: '#4aa94a',
      light: '#ffffff'
    },
    twitter: {
      creator: '@greenbow',
      site: '@greenbow'
    },
    locale: 'da_DK',
    colorScheme: 'dark light',
    verification: {
      google: 'D5Cml4TbewPFcdsYSKz5mhytR5EHPyoDK81bIBo5haw',
      ahrefs:
        'e29ea454dcfa13e83be93876c1e5c9e83e2d8c1b6306a42b454381a210497102',
      facebook: 'g7n5i9pb9mcbq9hvgh8hpaf0dl6dvy'
    }
  }
} as const;
